import { render } from "./TransactionList.m.vue?vue&type=template&id=1bb7a952"
import script from "./TransactionList.m.vue?vue&type=script&lang=js"
export * from "./TransactionList.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__